import React from "react";
import { useLocation } from "react-router-dom";
import MainContent from "../../components/mainContent/MainContent";
import { EnvioCreationContent } from "./components/EnvioCreationContent";

export default function EnvioCreation() {
  const location = useLocation();
  const { isNew } = location.state;

  return (
    <MainContent
      component={<EnvioCreationContent />}
      titulo={`${isNew ? "Nuevo" : "Editar"} envío`}
      noBackground
      tableMaxWidth
    />
  );
}
